import React from 'react';
import EventListFunctional from './components/event-list-functional';

const EventList = () => {
	return <EventListFunctional />;
};

export default EventList;
